/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SponsoredRewardResponse } from './SponsoredRewardResponse';
import {
    SponsoredRewardResponseFromJSON,
    SponsoredRewardResponseFromJSONTyped,
    SponsoredRewardResponseToJSON,
    SponsoredRewardResponseToJSONTyped,
} from './SponsoredRewardResponse';

/**
 * Collection contains the user's reward stats/progress.
 * @export
 * @interface SponsoredGuildCompetition
 */
export interface SponsoredGuildCompetition {
    /**
     * Mongo id of the competition
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    id: string;
    /**
     * Brand name to display on guild page
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    sponsorBrandName: string;
    /**
     * Image to display on guild page.
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<SponsoredRewardResponse>}
     * @memberof SponsoredGuildCompetition
     */
    rewards: Array<SponsoredRewardResponse>;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    runningYear: number;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    brandUrl: string;
    /**
     * BrandActivation shadow record ID
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    migratedToActivationId?: string;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the SponsoredGuildCompetition interface.
 */
export function instanceOfSponsoredGuildCompetition(value: object): value is SponsoredGuildCompetition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sponsorBrandName' in value) || value['sponsorBrandName'] === undefined) return false;
    if (!('promotionImage' in value) || value['promotionImage'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('runningMonth' in value) || value['runningMonth'] === undefined) return false;
    if (!('runningYear' in value) || value['runningYear'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('brandUrl' in value) || value['brandUrl'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SponsoredGuildCompetitionFromJSON(json: any): SponsoredGuildCompetition {
    return SponsoredGuildCompetitionFromJSONTyped(json, false);
}

export function SponsoredGuildCompetitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredGuildCompetition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(SponsoredRewardResponseFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'description': json['description'],
        'brandUrl': json['brandUrl'],
        'migratedToActivationId': json['migratedToActivationId'] == null ? undefined : json['migratedToActivationId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function SponsoredGuildCompetitionToJSON(json: any): SponsoredGuildCompetition {
    return SponsoredGuildCompetitionToJSONTyped(json, false);
}

export function SponsoredGuildCompetitionToJSONTyped(value?: SponsoredGuildCompetition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sponsorBrandName': value['sponsorBrandName'],
        'promotionImage': value['promotionImage'],
        'rewards': ((value['rewards'] as Array<any>).map(SponsoredRewardResponseToJSON)),
        'runningMonth': value['runningMonth'],
        'runningYear': value['runningYear'],
        'description': value['description'],
        'brandUrl': value['brandUrl'],
        'migratedToActivationId': value['migratedToActivationId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

